const cardsOptions = [
	{
		name: {
			first: 'Тариф',
			second: 'Чистий Гігабіт'
		},
		advantages: [
			{
				icon: require('../../assets/icons/speed.png'),
				text: '1000 Мбіт/c',
			},
			{
				icon: require('../../assets/icons/promo.png'),
				text: 'Акційне підключення'
			},
			{
				icon: require('../../assets/icons/support.png'),
				text: 'Технічна підтримка 24/7'
			}
		],
		cost: {
			unit: {
				currency: 'грн',
				month: 'міс'
			},
			// promoCost: 1000,
			fullCost: 199
		},
	},
	{
		name: {
			first: 'Роутер',
			second: 'TP-Link Archer C5 pro',
			detailsLink: '/router550'
		},
		advantages: [
			{
				icon: require('../../assets/icons/speed_circle.png'),
				text: 'Висока швидкість',
			},
			{
				icon: require('../../assets/icons/signal.png'),
				text: 'Стабільний сигнал'
			},
			{
				icon: require('../../assets/icons/cover.png'),
				text: 'Збільшена зона покриття'
			}
		],
		cost: {
			unit: {
				currency: 'грн',
			},
			promoCost: 1100,
			fullCost: 550
		},
		details: {
			button: 'Детальніше'
		}
	}
]

export default cardsOptions